import appConstants from "../../../../../appConstants";
import { StaticFilter, MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { CommandCellRenderer } from '@dataGrid/components/cellRenderer';
import { constants } from "../constants";
import { RepeatEveryYear } from "../../../Common/icons";
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import StyledToolTip from '../../../../common/StyledToolTip';
import {
  getHolidayDateValue,
  holidayValueGetter
} from '../../../CustomerManagement/EditCustomer/components/Holidays/utils';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration(config);
  }

  static getCommandCellRenderer = (params, isEditCustomerDialog) => {
    let commandConfig = {
      deleteCommand: 'deleteHoliday',
      deleteTitle: 'Delete Holiday'
    };
    if (!isEditCustomerDialog) {
      commandConfig = { ...commandConfig, editCommand: 'editHoliday', editTitle: 'Edit Holiday' };
    }
    return <CommandCellRenderer commandConfig={commandConfig} params={{ ...params }} />;
  };

  static getTerminalFilterOptions = (params) => {
    return params.context.userAccessibleTerminals;
  };

  static getCountryFilterOptions = (params) => {
    return params.context.countryList;
  };

  static formatRepeatHolidayField = ({ data }) => {
    if (data.isCustomerSpecificHoliday) {
        return '';
    }
    return data.shouldRepeatEveryYear ? 'Y' : 'N';
  };

  static getRepeatHolidayValue = (params) => {
    if (params.data.isCustomerSpecificHoliday) {
      return null;
    }
    return params.data.shouldRepeatEveryYear;
  };

  static holidayTypeCellRenderer = (params) => {
    if (params.value) {
      return (
        <div
          style={{
            padding: '8px 16px 0 0'
          }}>
          <StyledToolTip title="Customer specific holiday">
            <PersonOutlinedIcon />
          </StyledToolTip>
        </div>
      );
    }
    return null;
  };

  static getDefaultConfiguration({isEditCustomerDialog = false}) {
    const actionColWidth = isEditCustomerDialog
      ? appConstants.columnWidth.W_70
      : appConstants.columnWidth.W_100;
    return {
      keyColumn: "holidayId",
      rowSelection: "single",
      defaultColDef: {
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: "holidayId",
          field: "holidayId",
          hide: true,
          headerTooltip: "holiday Id",
        },
        {
          headerName: "Holiday Name",
          headerTooltip: "Holiday Name",
          field: "holidayName",
          filter: MultiSelectFilter,
          cellDataType: 'text',
          minWidth: appConstants.columnWidth.W_150,
        },
        {
          headerName: 'Type',
          headerTooltip: 'Holiday Type',
          field: 'isCustomerSpecificHoliday',
          cellRenderer: GridConfig.holidayTypeCellRenderer,
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_80,
          maxWidth: appConstants.columnWidth.W_120,
          hide: !isEditCustomerDialog
        },
        {
          headerName: 'Date',
          headerTooltip: 'Holiday Date',
          field: 'holidayDate',
          cellRenderer: getHolidayDateValue,          
          filter: DateTimeFilter,
          valueGetter: holidayValueGetter,          
          filterParams: {
            DATETYPE: appConstants.DATETYPES.MONTHDATEYEAR,
            useGetterValue: true
          },
          minWidth: appConstants.columnWidth.W_140
        },
        {
          headerName: "Weekday",
          headerTooltip: "Weekday",
          field: "dow",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
          hide: isEditCustomerDialog
        },
        {
          headerName: "Terminal",
          valueGetter: (params) => {
            return params.data.terminalApplicable || [];
          },
          minWidth: appConstants.columnWidth.W_120,
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getTerminalFilterOptions,
          },
          tooltipField: "terminalApplicable",
          hide: isEditCustomerDialog
        },
        {
          headerName: "Country",
          valueGetter: (params) => {
            return params.data.countryApplicable || [];
          },
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getCountryFilterOptions,
          },
          minWidth: appConstants.columnWidth.W_120,
          tooltipField: "countryApplicable",
          hide: isEditCustomerDialog
        },
        {
          headerTooltip: "Repeat Every Year",
          headerIcon: RepeatEveryYear,
          filter: StaticFilter,
          valueGetter: GridConfig.getRepeatHolidayValue,
          valueFormatter: GridConfig.formatRepeatHolidayField,
          filterParams: {
            staticOptions: Object.values(constants.repeatEveryYearOptions),
          },
          minWidth: appConstants.columnWidth.W_70,
          maxWidth: appConstants.columnWidth.W_70,
        },
        {
          headerName: "Action",
          field: "command",
          cellRenderer: (params) =>
            GridConfig.getCommandCellRenderer(params, isEditCustomerDialog),
          minWidth: actionColWidth,
          maxWidth: actionColWidth,
          filter: false,
          sortable: false,
        },
      ],
    };
  }
}
